/**
 * Remembers the page the user asked for across the Logto sign-in round trip
 * (which always comes back on /callback), so they land where they were going
 * instead of on the landing page.
 */
const RETURN_TO_KEY = 'auth_return_to';

/** Paths that must never be restored after sign-in (auth plumbing). */
function isRestorable(path: string): boolean {
  return (
    path.startsWith('/') &&
    !path.startsWith('//') &&
    path !== '/' &&
    !path.startsWith('/callback') &&
    !path.startsWith('/auth/callback')
  );
}

export function rememberReturnTo(path: string): void {
  if (!isRestorable(path)) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    /* sessionStorage unavailable — fall back to the landing page */
  }
}

/** Returns the remembered path (once) or null. */
export function consumeReturnTo(): string | null {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return path && isRestorable(path) ? path : null;
  } catch {
    return null;
  }
}
